@import 'styles/variables';
@import 'styles/mixins';

.content {
  padding: 14px;
  overflow: auto;

  @include for-phone-only {
    flex: 1 1 0;
    min-height: 0;
  }

  [data-autopilot-system-redesign='on'] & {
    padding: 35px 40px;
    background: var(--light-100);

    @include for-desktop-only {
      &.compact {
        padding: 0 40px 35px 40px;
      }

      &.isConfirmation {
        padding: 0 25px 25px 25px;
      }
    }

    &.withoutFooter {
      padding: 40px;
      border-radius: 0 0 16px 16px;

      @include for-desktop-only {
        &.compact {
          padding: 0 40px 40px 40px;
        }

        &.isConfirmation {
          padding: 0 25px 25px 25px;
        }
      }
    }

    @include for-phone-only {
      padding: 8px 16px;
    }
  }

  &.fillAvailableSpace {
    padding: 0;
  }
}

.fillAvailableSpace {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  width: 100%;
}

@media (min-width: $tabletPortraitMinWidth) {
  .content {
    padding: 0 20px;
    overflow: unset;
  }
}
